class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.cartIcon = document.querySelector("cart-icon");
    this.quantity__button = document.querySelectorAll("quantity-input");
    this.overflowContent = document.querySelector(".cart-notification-product");
    this.addToCarts = document.querySelectorAll(".product-form__submit");
    this.addToCarts.forEach((addToCart) => {
      addToCart.addEventListener("click", (e) => this.cartIcon.openDrawer(e));
    });
    this.closeWays();
  }


  closeWays() {
    this.overlay = document.querySelector(".cart-drawer-overlay");
    this.overlay.addEventListener("click", (e) => this.closeDrawer(e));
    this.closeButton = document.querySelectorAll(".cart-drawer-close");
    this.closeButton.forEach((closeButton) => {
      closeButton.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        this.closeDrawer(e);
      });
    });
  }

  closeDrawer(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    this.setAttribute("open", false);
    document.querySelector("html").classList.remove("cart-opened");
    document.querySelector("body").classList.remove("cart-opened");
  }

  renderContents(e) {
    this.variantId = e.variant_id;
    this.getSectionsToRender().forEach((section) => {
      if (document.querySelector(section.selector)) {
        document.querySelector(section.selector).innerHTML =
          this.getSectionInnerHTML(e.sections[section.id], section.selector);
      }
    });
    if (this.header) this.header.reveal();
    if (document.querySelector(".cart-drawer-body"))
      document.querySelector(".cart-drawer-body").style.display = "none";

    // Update upsell in cart-drawer.liquid
    window.dispatchEvent(new Event('updateCart', { bubbles: true }));
    this.closeWays();
  }

  renderEmpty(e) {
    const sections = [
      {
        id: "cart-drawer",
        selector: "cart-drawer",
      },
    ];
    sections.forEach((section) => {
      document.querySelector("cart-drawer").innerHTML =
        this.getSectionInnerHTML(e.sections[section.id], section.selector);
    });
    document.querySelector(".cart-count-bubble").innerHTML = "";
    if (this.header) this.header.reveal();
    this.closeWays();
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-icon-bubble",
        selector: ".cart-count-bubble",
      },
      {
        id: "cart-drawer",
        selector: "#cart-drawer .cart-drawer-header",
      },
      {
        id: "cart-drawer",
        selector: "#cart-drawer .cart-drawer-shipping",
      },
      {
        id: "cart-drawer",
        selector: "#cart-notification-product .js_content",
      },
      {
        id: "cart-drawer",
        selector: "#cart-drawer .cart__footer",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define("cart-drawer", CartDrawer);

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      // this.closest('cart-drawer').updateQuantity(this.dataset.index, 0);

      this.cartDrawer = document.querySelector("cart-drawer");
      this.cartIcon = document.querySelector("cart-icon");
      this.cartDrawer.setActiveElement(document.activeElement);

      this.url = this.querySelector("a").href;
      const config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      config.body = JSON.stringify({
        // id: this.input.getAttribute("data-variant-id"),
        quantity: 0,
        sections: this.cartDrawer
          .getSectionsToRender()
          .map((section) => section.id),
        sections_url: window.location.pathname,
      });
      fetch(`${this.url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          if (response.item_count === 0) {
            this.cartDrawer.renderEmpty(response);
          } else {
            this.cartDrawer.renderContents(response);
            this.cartIcon.forceDrawer();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    });
  }
}
customElements.define("cart-remove-button", CartRemoveButton);
